import Button from "components/buttonNew/button";
import Markdown from "components/markdown/markdown";
import Image from "components/imageNew/image";
import { getDateString } from "../utils";
import type { AboutPageData } from "content-ui/utilityPages/about/types";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";

type BrandKitProps = {
  data: AboutPageData["aboutPage"];
};

export default function BrandKit({ data }: BrandKitProps) {
  const { track } = useMixpanelTracking();
  return (
    <div className="text-mono-70">
      <h2 className="mb-[12px] font-bold text-[18px] text-black-rock">
        {data.brandKitHeading}
      </h2>
      <div className="flex flex-col md:items-center lg:flex-row lg:items-start">
        <div className="mb-[38px] flex flex-shrink-0 items-center justify-center md:justify-start">
          <Image
            src={data.brandKitImage?.url}
            alt={data.brandKitImage?.alt || ""}
            width={data.brandKitImage?.width}
            height={data.brandKitImage?.height}
            blurDataURL={data.brandKitImage?.blurUpThumb}
            className="h-[214px] w-[340px] object-cover lg:h-[214px] lg:w-[320px]"
            sizes="(min-width: 1280px) 320px, 340px"
          />
        </div>

        <div className="lg:ml-10">
          {data.brandKitUpdatedAt && (
            <p className="mb-[10px] text-[14px] text-[#767683]">
              Updated <time>{getDateString(data.brandKitUpdatedAt)}</time>
            </p>
          )}

          {data.brandKitText && (
            <Markdown
              text={data.brandKitText}
              className="text-normal mb-[30px] text-sm md:mb-[20px] lg:mb-[30px] [&_a]:underline"
            />
          )}

          {data.brandKitCtaText && (
            <Button
              colour={data.brandKitCtaColor || "black"}
              size={"small"}
              component={"link"}
              href={data.brandKitCtaLink}
              onClick={async () => {
                track("About page click", {
                  "Click link": data.brandKitCtaLink,
                  "Click text": data.brandKitCtaText,
                });
              }}
            >
              {data.brandKitCtaText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
